import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		phoneNumber: ""
	},
	mutations: {
		getPhoneNumber(state, param) {
			state.phoneNumber = param;
		}
	},
	actions: {
		changePhoneNumber({ commit }, param) {
			commit("getPhoneNumber", param);
		}
	}
});
export default store;
